import logo from "@/assets/postflow-logo.png";
import { Link } from "react-router-dom";

const EMAIL = "contato@ctr2sr.com.br";
const UPDATED = "Junho de 2026";

export default function Privacidade() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800" data-testid="privacy-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-6 py-4">
          <img src={logo} alt="PostFlow AI" className="h-9 w-9 rounded-lg" />
          <div>
            <div className="font-display text-lg font-extrabold text-slate-900">PostFlow AI</div>
            <div className="text-xs text-slate-500">Política de Privacidade</div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">Política de Privacidade</h1>
        <p className="mt-2 text-sm text-slate-500">Última atualização: {UPDATED}</p>

        <section className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed [&_h2]:mt-8 [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mt-1">
          <p>
            A PostFlow AI ("nós", "nosso" ou "plataforma"), operada por CTR2, respeita a sua privacidade e está
            comprometida em proteger os dados pessoais tratados no uso da nossa aplicação de planejamento e publicação
            de conteúdo em redes sociais. Esta política explica quais dados coletamos, como os utilizamos e quais são
            os seus direitos, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).
          </p>

          <h2>1. Dados que coletamos</h2>
          <ul>
            <li><strong>Dados de conta:</strong> nome, e-mail e senha (armazenada de forma criptografada).</li>
            <li><strong>Dados da marca/empresa:</strong> nome, nicho, descrição, tom de voz, cores, telefone, site,
              redes sociais e demais informações que você cadastrar.</li>
            <li><strong>Conteúdos gerados:</strong> textos, legendas, roteiros e imagens criados na plataforma.</li>
            <li><strong>Dados de integração com redes sociais:</strong> ao conectar contas do Instagram/Facebook via
              login oficial da Meta, recebemos tokens de acesso e informações básicas da Página e da conta comercial
              necessárias exclusivamente para publicar o conteúdo autorizado por você.</li>
            <li><strong>Dados de uso:</strong> registros técnicos e de auditoria para segurança e funcionamento.</li>
          </ul>

          <h2>2. Como usamos os dados</h2>
          <ul>
            <li>Fornecer, operar e manter a plataforma e seus recursos de IA.</li>
            <li>Gerar e publicar conteúdo nas redes sociais que você conectar e autorizar.</li>
            <li>Melhorar a experiência, a segurança e o suporte ao usuário.</li>
            <li>Cumprir obrigações legais e regulatórias.</li>
          </ul>

          <h2>3. Compartilhamento de dados</h2>
          <p>
            Não vendemos seus dados. Compartilhamos informações apenas com provedores necessários para o funcionamento
            do serviço (por exemplo, APIs da Meta/Instagram para publicação e provedores de IA para geração de
            conteúdo), sempre limitado à finalidade autorizada por você, e com autoridades quando exigido por lei.
          </p>

          <h2>4. Integração com a Meta (Instagram e Facebook)</h2>
          <p>
            O uso de dados obtidos das APIs da Meta segue as Políticas da Plataforma Meta. Os tokens de acesso são
            usados unicamente para publicar e gerenciar o conteúdo que você solicitar. Você pode revogar o acesso a
            qualquer momento nas configurações da sua conta do Facebook/Instagram ou dentro da PostFlow AI.
          </p>

          <h2>5. Armazenamento e segurança</h2>
          <p>
            Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo criptografia de senhas,
            controle de acesso e comunicação por HTTPS. Nenhum método é 100% seguro, mas trabalhamos continuamente
            para reduzir riscos.
          </p>

          <h2>6. Seus direitos (LGPD)</h2>
          <p>
            Você pode solicitar acesso, correção, portabilidade, anonimização ou exclusão dos seus dados, bem como
            revogar consentimentos. Para exercer esses direitos, entre em contato pelo e-mail{" "}
            <a href={`mailto:${EMAIL}`} className="text-[#3457d5] font-semibold">{EMAIL}</a>. Consulte também nossa{" "}
            <Link to="/exclusao-de-dados" className="text-[#3457d5] font-semibold">página de Exclusão de Dados</Link>.
          </p>

          <h2>7. Retenção e exclusão</h2>
          <p>
            Mantemos seus dados enquanto sua conta estiver ativa ou conforme necessário para as finalidades descritas.
            Ao solicitar a exclusão, removemos seus dados pessoais e tokens de integração, exceto quando a retenção
            for exigida por lei.
          </p>

          <h2>8. Alterações desta política</h2>
          <p>
            Podemos atualizar esta política periodicamente. A data de "última atualização" no topo indica a versão
            vigente.
          </p>

          <h2>9. Contato</h2>
          <p>
            Dúvidas sobre privacidade? Fale com o encarregado de dados pelo e-mail{" "}
            <a href={`mailto:${EMAIL}`} className="text-[#3457d5] font-semibold">{EMAIL}</a>.
          </p>
        </section>

        <div className="mt-10 border-t border-slate-200 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm">
          <Link to="/" className="text-[#3457d5] font-semibold" data-testid="privacy-home-link">← Voltar ao início</Link>
          <nav className="flex flex-wrap gap-x-4 gap-y-1 text-slate-500">
            <Link to="/termos" className="hover:text-[#3457d5]">Termos</Link>
            <Link to="/privacidade" className="hover:text-[#3457d5]">Privacidade</Link>
            <Link to="/exclusao-de-dados" className="hover:text-[#3457d5]">Exclusão de Dados</Link>
          </nav>
        </div>
      </main>
    </div>
  );
}
